import { ReceivingLogRow } from "./ReceivingLogRow";

export class ApiReceivingLogRow {
    id?: number;
    vendor?: string;
    jobNumber?: string;
    jobName?: string;
    jcDept?: string;
    poNumber?: string;
    items?: string;
    email?: string;
    quantity?: string;
    location?: string;
    dateIn?: string | null;
    dateOut?: string | null;
    takenBy?: string;
    shopFloorSF?: number;
    shipmentType?: string;
    loggedBy?: string;
    checkedOut?: boolean;
    notes?: string;
    storageFacility?: string;

    // Clear flags that don't exist in the original model
    clearDateIn?: boolean;
    clearDateOut?: boolean;
  
    public constructor(init?: Partial<ReceivingLogRow>) {
      if (init) {
        // Copy all properties from init to this object
        Object.assign(this, init);
        
        // Check if dateIn is explicitly included but null/empty
        // This would indicate the user intentionally cleared the field
        if ('dateIn' in init) {
          if (init.dateIn && init.dateIn !== '' && init.dateIn !== undefined) {
            // Normal case - convert date to ISO string
            this.dateIn = new Date(init.dateIn).toISOString();
            this.clearDateIn = false;
          } else {
            // Field was explicitly set to null/empty
            this.dateIn = null;
            this.clearDateIn = true;
          }
        }
        
        // Same logic for dateOut
        if ('dateOut' in init) {
          if (init.dateOut && init.dateOut !== '' && init.dateOut !== undefined) {
            // Normal case - convert date to ISO string
            this.dateOut = new Date(init.dateOut).toISOString();
            this.clearDateOut = false;
          } else {
            // Field was explicitly set to null/empty
            this.dateOut = null;
            this.clearDateOut = true;
          }
        }
      }
    }
}